import { Button } from 'antd'
import { AuthorizedDropdown } from '@/features/authorization/authorized-dropdown.tsx'

export type GroupAction = 'print' | 'receipt' | 'void'
export function GroupActions({
  canManage,
  onAction,
  label = '更多',
  disabled = false,
  status,
  printHref,
  receiptHref
}: {
  canManage: boolean
  onAction: (action: GroupAction) => void
  label?: string
  disabled?: boolean
  receiptHref?: string
  printHref?: string
  status?: string
}) {
  return (
    <AuthorizedDropdown
      resource="bill.group"
      trigger={['click']}
      disabled={disabled}
      menu={{
        items: [
          {
            key: 'print',
            label:
              printHref && status !== 'draft' ? (
                <a href={printHref} target="_blank" rel="noopener noreferrer">
                  打印收据
                </a>
              ) : (
                '打印收据'
              ),
            disabled: status === 'draft'
          },
          ...(canManage
            ? [
                {
                  key: 'receipt',
                  label: receiptHref ? (
                    <a href={receiptHref} target="_blank" rel="noopener noreferrer">
                      批量登记收款
                    </a>
                  ) : (
                    '登记收款'
                  ),
                  disabled: !!status && status !== 'issued'
                },
                { key: 'void', label: '作废并释放账单', danger: true, disabled: status === 'voided' }
              ]
            : [])
        ],
        onClick: ({ key }) => {
          if (!(key === 'print' && printHref) && !(key === 'receipt' && receiptHref)) {
            onAction(key as GroupAction)
          }
        }
      }}
    >
      <Button type={label === '更多' ? 'link' : 'default'} disabled={disabled}>
        {label}
      </Button>
    </AuthorizedDropdown>
  )
}
